// @todo: Migrate to 'Checkbox' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Checkbox} from '@wandb/weave/components/Checkbox';
import {clsx} from 'clsx';
import React, {useState} from 'react';
import {v4 as uuidv4} from 'uuid';

export type DiffToggleProps = {
  diffOnly?: boolean;
  onChange: (diffOnly: boolean) => void;
  className?: string;
};

const DiffToggle = ({
  diffOnly = false,
  onChange,
  className,
}: DiffToggleProps) => {
  const id = uuidv4();
  // Use local state to allow for immediate updates to the UI while the tree re-renders in the background.
  const [localChecked, setLocalChecked] = useState<boolean>(diffOnly);

  return (
    <div
      className={clsx('diff-toggle-wrapper', className, {
        'diff-only': localChecked,
      })}>
      <Checkbox
        data-test="run-comparer-diff-only"
        onCheckedChange={(checked: boolean) => {
          setLocalChecked(checked);
          onChange(checked);
        }}
        className="diff-only-toggle"
        checked={localChecked}
        id={id}
        disabled={diffOnly !== localChecked} // Disable the checkbox if the diffOnly prop is out of sync with the local state - this means the tree is still updating.
      />
      <label htmlFor={id} className="diff-only-label">
        diff only
      </label>
    </div>
  );
};

export default DiffToggle;
